import { Box, Divider, Typography } from '@mui/material';
import { NavBar } from '../appBars/navBar/navBar';
import { CustomerInfo } from 'orderme-api-integration-client';
import { RootState } from '../../redux/store';
import { ActivateCoupon } from './activateCoupon';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '../../redux/hooks';
import { BreadcrumbsBar } from '../breadcrumbs/breadcrumbsBar';
import { BuyCredits } from './buyCredits';
import { appStyleMode, IsSewingCompany } from '../../helpers/clientConfigs';
import { AppStyle } from '../../helpers/appStyle';
import { CreditsRoute } from '../../routes/allRoutes';
import AccountBalanceWalletOutlinedIcon from '@mui/icons-material/AccountBalanceWalletOutlined';

export function Credits() {
  const { t } = useTranslation();

  const customerInfo: CustomerInfo = useAppSelector((state: RootState) => state.customerState.customerInfo);
  const isUserLoggedIn: boolean = useAppSelector((state: RootState) => state.authState.isLoggedIn);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      <NavBar barTitle={(t('credits:creditsAndCoupons') as string).toUpperCase()} />
      <BreadcrumbsBar paths={[{ path: CreditsRoute }]} />
      {/* Group 1 + Divider + Group 2 in a single white card */}
      <Box
        sx={{ backgroundColor: 'white', borderRadius: '15px', px: '20px' }}
        className={appStyleMode === AppStyle.Mobile ? 'credits-box' : undefined}
      >
        {/* Group 1: Balance + Coupon */}
        {isUserLoggedIn && (
          <>
            {/* Balance row */}
            <Box
              sx={{
                display: 'flex',
                flexWrap: 'wrap',
                alignItems: 'center',
                pt: '10px',
              }}
            >
              <Box
                sx={{
                  width: '48px',
                  height: '48px',
                  borderRadius: '12px',
                  backgroundColor: 'appBar.top.background',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexShrink: 0,
                }}
              >
                <AccountBalanceWalletOutlinedIcon sx={{ color: 'white', fontSize: '24px' }} />
              </Box>
              <Box sx={{ flex: 1, minWidth: '120px', ml: '16px' }}>
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    flexWrap: 'wrap',
                  }}
                >
                  <Typography variant="body2" sx={{ color: 'black' }}>
                    {t('credits:totalCredits')}
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: { xs: '20px', sm: '28px' },
                      fontWeight: 'bold',
                      color: 'appBar.top.background',
                    }}
                  >
                    {customerInfo.credit?.toPrice()}
                  </Typography>
                </Box>
                <Typography variant="body2" sx={{ color: 'text.disabled' }}>
                  {IsSewingCompany ? t('payment:creditsCanBeUsedForSewing') : t('payment:creditsCanBeUsedForLaundry')}
                </Typography>
              </Box>
            </Box>

            {/* Coupon row */}
            <Box sx={{ pb: '20px', mt: { xs: '10px', sm: '20px' } }}>
              <ActivateCoupon />
            </Box>

            {/* Divider between Group 1 and Group 2 */}
            <Divider>
              <Typography sx={{ color: 'black', textTransform: 'uppercase' }}>{t('credits:buyCredits')}</Typography>
            </Divider>
          </>
        )}

        {/* Group 2: Buy credits */}
        <Box sx={{ py: '20px' }}>
          <BuyCredits />
        </Box>
      </Box>
    </Box>
  );
}
